import React from "react";
import { iUser } from "../../interfaces/iUser";
import FindDialog, { FindOption } from "../Generic/FindDialog";
import { iActionProps, iEnquiry } from "../../interfaces/iEnquiry";
import { UpdateEnquiriesstatusRequest, UpdateEnquiriesStatus } from "../../Logic/EmsAPI/Enquiries";
import Statuses from "../../interfaces/Statuses";

interface Props extends iActionProps {
    enquiries: Array<iEnquiry>;
}
function ChangeEnquiryStatus(props: Props) {
    async function UpdateEnquriesStatus(value: string) {
        if (value != "") {
            let updateEnquiriesstatusRequest: UpdateEnquiriesstatusRequest = {
                StatusID: +value,
                Enquiries: props.enquiries.map(enq => enq.id),
            };

            const response = await UpdateEnquiriesStatus(updateEnquiriesstatusRequest);

            if (!response.isOk) {
                props.onError("Unable to change enquiry status.", response.errorLogID);
                return;
            }

            props.onCreated();
        }
    }

    const StatusList = Object.values(Statuses)
        .filter((item: any) => typeof item === "object" && "ID" in item)
        .map(s => ({
            id: s.ID,
            name: s.Name,
        }));

    return (
        <>
            {StatusList != undefined && StatusList.length > 0 ? (
                <FindDialog
                    title="Change Enquiry Status"
                    onCancel={() => props.onCancel()}
                    onConfirm={selectedValue => {
                        if (selectedValue !== "") {
                            UpdateEnquriesStatus(selectedValue);
                        }
                    }}
                    values={StatusList!
                        .filter(x => x.id !== 7)
                        .map<FindOption>(x => {
                            return {
                                label: x.name,
                                value: x.id.toString(),
                            };
                        })}
                />
            ) : (
                <></>
            )}
        </>
    );
}
export default ChangeEnquiryStatus;
